import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
//primeReact

import { Button } from "primereact/button";

//components
import Input from "../../../../components/input/Input";
import Select from "../../../../components/input/Select";
import NumberInput from "../../../../components/input/NumberInput";
//services

import TextareaInput from "../../../../components/input/TextareaInput";
import { Tooltip } from "primereact/tooltip";
import CopyTextInput from "../../../../components/input/CopyTextInput";
import Modal from "../../../../components/modal/Modal";
import { putSendDays } from "../../../../services/Enterprise/Email/putSendDays";
import { Editor } from "primereact/editor";

const EmailEdit = ({
  visible,
  headerModal,
  handleCloseModal,
  send_days,
  setVisible,
  rowData,
  refetch,
}) => {
  const form = useForm();
  const errors = form.formState.errors;
  const { id: enterpriseId } = useParams(); // Pega o enterprise_id da URL

  const [loading, setLoading] = useState(false);
  const [text, setText] = useState(rowData.text || "");
  const variables = [
    { id: 1, name: "@nome_cli" },
    { id: 2, name: "@nome_empreendimento" },
    { id: 3, name: "@valor_parcelas" },
    { id: 4, name: "@data_vencimento" },
    { id: 5, name: "@quadra" },
    { id: 6, name: "@lote" },
    { id: 7, name: "@link_boleto" },
  ];

  const condition = [
    { value: "before", label: "Antes do Vencimento" },
    { value: "after", label: "Após o vencimento" },
  ];

  const sendEditEmail = async (data) => {
    data.text = text;
    data.enterprise_id = enterpriseId; // Adiciona o enterprise_id da URL

    // console.log("Dados sendo enviados:", data);

    try {
      const notification = toast.loading("Por favor aguarde...");
      setLoading(true);

      await putSendDays(data);

      toast.update(notification, {
        render: "Alteração realizada com sucesso!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      refetch();
    } catch (e) {
      toast.error(`Não foi possível alterar dia de envio!`);
    }
    setLoading(false);
  };

  //  // console.log(rowData);
  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  useEffect(() => {
    // console.log({ rowData });
    form.setValue("id", `${rowData.id}`);
    form.setValue("type", `${rowData.type}`);
    form.setValue("status", `${rowData.status}`);
    form.setValue("reply_to_name", `${rowData.reply_to_name}`);
    form.setValue("reply_to", `${rowData.reply_to}`);
    form.setValue("subject", `${rowData.subject || ""}`);
    form.setValue("days", `${rowData.days}`);
    form.setValue("before_or_after", `${rowData.before_or_after}`);
    form.setValue("text", `${rowData.text}`);

  }, [visible]);

  return (
    <>
      <Modal
        id="modal_cad"
        className="rounded-4"
        dynamicTitle={"Edite as configurações de disparo de emails"}
        visible={visible}
        header={"Editar Email"}
        onHide={() => setVisible(false)}
        dynamicWidth={window.innerWidth <= 992 ? "85vw" : "90vw"}
      >
        <form onSubmit={form.handleSubmit(sendEditEmail)}>
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-4 mt-4">
                  <h4>
                    {" "}
                    Email de Resposta
                    <Tooltip target=".custom-target-icon" />
                    <i
                      className="custom-target-icon px-2 pi 
                      pi-info-circle p-text-secondary"
                      data-pr-tooltip="Configure a quantidade de dias que sera enviada antes ou após o vencimento do boleto"
                      style={{ cursor: "pointer" }}
                    ></i>{" "}
                  </h4>
                  <Input
                    suffix=""
                    isRequired={true}
                    name="reply_to"
                    control={form.control}
                    label="Email de Resposta"
                    getFormErrorMessage={getFormErrorMessage}
                  />
                </div>

                <div className="col-md-4 mt-4">
                  <h4>
                    {" "}
                    Assunto da Resposta
                    <Tooltip target=".custom-target-icon" />
                    <i
                      className="custom-target-icon mx-2 pi 
                      pi-info-circle p-text-secondary"
                      data-pr-tooltip="Configure se a mensagem será de cobrança ou lembrete"
                      style={{ cursor: "pointer" }}
                    ></i>
                  </h4>
                  <Input
                    isRequired={true}
                    name="reply_to_name"
                    control={form.control}
                    label="Resposta"
                    getFormErrorMessage={getFormErrorMessage}
                  />
                </div>

                <div className="col-md-4 mt-4">
                  <h4>
                    {" "}
                    Assunto Envio
                    <Tooltip target=".custom-target-icon" />
                    <i
                      className="custom-target-icon mx-2 pi 
                      pi-info-circle p-text-secondary"
                      data-pr-tooltip="Configure o assunto do email que será enviado"
                      style={{ cursor: "pointer" }}
                    ></i>
                  </h4>
                  <Input
                    suffix=""
                    isRequired={true}
                    name="subject"
                    control={form.control}
                    label="Assunto Envio"
                    getFormErrorMessage={getFormErrorMessage}
                  />
                </div>
                <hr className="my-4" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-6 mt-4">
                  <h4>
                    {" "}
                    Quantidade de Dias
                    <Tooltip target=".custom-target-icon" />
                    <i
                      className="custom-target-icon px-2 pi 
                    pi-info-circle p-text-secondary"
                      data-pr-tooltip="Configure a quantidade de dias que sera enviada antes ou após o vencimento do boleto"
                      style={{ cursor: "pointer" }}
                    ></i>{" "}
                  </h4>
                  <NumberInput
                    suffix=""
                    placeholder="0"
                    max={90}
                    required={true}
                    minFractionDigits={0}
                    name="days"
                    control={form.control}
                    label="Dias"
                    getFormErrorMessage={getFormErrorMessage}
                  />
                </div>
                <div className="col-md-6 mt-4">
                  <h4>
                    {" "}
                    Condição
                    <Tooltip target=".custom-target-icon" />
                    <i
                      className="custom-target-icon mx-2 pi 
                    pi-info-circle p-text-secondary"
                      data-pr-tooltip="Configure se a mensagem será de cobrança ou lembrete"
                      style={{ cursor: "pointer" }}
                    ></i>
                  </h4>
                  <Select
                    isRequired={true}
                    name="before_or_after"
                    // errors={errors}
                    label="Escolha"
                    options={condition}
                    control={form.control}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <h4>
                Variáveis <Tooltip target=".custom-target-icon" />
                <i
                  className="custom-target-icon px-2 pi 
              pi-info-circle p-text-secondary"
                  data-pr-tooltip="Utilize para automatizar dados da mensagem"
                  style={{ cursor: "pointer" }}
                ></i>{" "}
              </h4>
              <div className="d-flex flex-wrap">
                {variables.map((v) => (
                  <div className="p-2 my-1" key={v.id}>
                    <CopyTextInput
                      text={v.name}
                      onClick={() => {
                        toast.success(`Texto copiado com sucesso`);
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>

            <div className="row">
              <div className="col-md-8 mt-4">
                <h4>
                  {" "}
                  Modelo de Envio
                  <Tooltip target=".custom-target-icon" />
                  <i
                    className="custom-target-icon px-2 pi 
        pi-info-circle p-text-secondary"
                    data-pr-tooltip="Configure sua mensagem para disparo de avisos de cobrança"
                    style={{ cursor: "pointer" }}
                  ></i>{" "}
                </h4>
                <Editor
                  key={rowData.id}
                  name="text"
                  control={form.control}
                  value={text}
                  onTextChange={(e) => setText(e.htmlValue)}
                  style={{ height: "320px" }}
                />
              </div>
              <div className="col-md-4 mt-4 align-self-end text-end">
                {" "}
                <Button
                  rounded
                  type="submit"
                  loading={loading}
                  iconPos="right"
                  label="Alterar"
                  icon="fa-solid fa-circle-chevron-right"
                  className="p-inputtext-sm m-auto"
                />
              </div>
            </div>
            <hr className="my-4" />
          </div>
        </form>
      </Modal>
    </>
  );
};

export default EmailEdit;
